import Vue from "vue";
import VueX from "vuex";
import bus from "@/ask/eventBus"

Vue.use(VueX);

export default new VueX.Store({
  state: {
    channelNameList: [], // 渠道名称集合
  },
  mutations: {
    SET_CHANNElDATA(state, list) {
      state.channelNameList = list;
      bus.$emit("saveChannelCallback", list);
    },
  },
  action: {},
});



// WEBPACK FOOTER //
// ./src/store/index.js